import MessageApi from '../../../../api/inbox/message';
import types from '../../../mutation-types';

export default {
  // Errors are intentionally NOT caught here - MessageContextMenu.vue's handleTranslate
  // catches the rejection and shows an alert. A silent catch here previously made every
  // translate failure (missing config, upstream error) indistinguishable from success.
  async translateMessage(
    { commit },
    { conversationId, messageId, targetLanguage }
  ) {
    commit(types.SET_MESSAGE_TRANSLATING, { messageId, isTranslating: true });
    try {
      await MessageApi.translateMessage(
        conversationId,
        messageId,
        targetLanguage
      );
    } finally {
      commit(types.SET_MESSAGE_TRANSLATING, {
        messageId,
        isTranslating: false,
      });
    }
  },
};
